import {Badges, DivisionsService} from '../../../../shared/modules/core/services/divisions.service';

export const services = {
  /*---------------------------------------------------------------
  ---------------------- LEAGUE OF LEGENDS ------------------------
  ---------------------------------------------------------------*/
  'lol': [
    {
      service: 'divisions',
      name: 'Divisions',
      url: '/lol-boost',
      icon: 'https://cdn.ggboost.com/images/services/lol/divisions.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Iron IV', 'lol'),
      soloCurrentMax: DivisionsService.getValueByRank('Master', 'lol'),
      soloDesiredMin: DivisionsService.getValueByRank('Iron III', 'lol'),
      soloDesiredMax: DivisionsService.getValueByRank('Grandmaster', 'lol'),
      duoCurrentMin: DivisionsService.getValueByRank('Iron IV', 'lol'),
      duoCurrentMax: DivisionsService.getValueByRank('Diamond I', 'lol'),
      duoDesiredMin: DivisionsService.getValueByRank('Iron III', 'lol'),
      duoDesiredMax: DivisionsService.getValueByRank('Master', 'lol'),
      isDuoAvailable: true,
      isSoloAvailable: true,
    },
    {
      service: 'placements',
      name: 'Placements',
      url: '/lol-boost/placements',
      icon: 'https://cdn.ggboost.com/images/services/lol/placements.webp',
      soloCurrentMin: 0,
      soloCurrentMax: DivisionsService.getValueByRank('Grandmaster', 'lol'),
      soloDesiredMin: 1,
      soloDesiredMax: 5,
      duoCurrentMin: 0,
      duoCurrentMax: DivisionsService.getValueByRank('Grandmaster', 'lol'),
      duoDesiredMin: 1,
      duoDesiredMax: 5,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'netwins',
      name: 'Net Wins',
      url: '/lol-boost/net-wins',
      icon: 'https://cdn.ggboost.com/images/services/lol/netwins.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Iron IV', 'lol'),
      soloCurrentMax: DivisionsService.getValueByRank('Grandmaster', 'lol'),
      soloDesiredMin: 1,
      soloDesiredMax: 5,
      duoCurrentMin: DivisionsService.getValueByRank('Iron IV', 'lol'),
      duoCurrentMax: DivisionsService.getValueByRank('Master', 'lol'),
      duoDesiredMin: 1,
      duoDesiredMax: 5,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'games',
      name: 'Games',
      url: '/lol-boost/games',
      icon: 'https://cdn.ggboost.com/images/services/lol/games.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Diamond IV', 'lol'),
      soloCurrentMax: DivisionsService.getValueByRank('Grandmaster', 'lol'),
      soloDesiredMin: 1,
      soloDesiredMax: 10,
      duoCurrentMin: DivisionsService.getValueByRank('Iron IV', 'lol'),
      duoCurrentMax: DivisionsService.getValueByRank('Grandmaster', 'lol'),
      duoDesiredMin: 1,
      duoDesiredMax: 10,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    // {
    //   service: 'masteries',
    //   name: 'Masteries',
    //   url: '/lol-boost/champion-mastery',
    //   icon: 'https://cdn.ggboost.com/images/services/lol/masteries.webp',
    //   soloCurrentMin: 0,
    //   soloCurrentMax: 9,
    //   soloDesiredMin: 1,
    //   soloDesiredMax: 10,
    //   duoCurrentMin: null,
    //   duoCurrentMax: null,
    //   duoDesiredMin: null,
    //   duoDesiredMax: null,
    //   isDuoAvailable: false,
    //   isSoloAvailable: true
    // },
    {
      service: 'normalgames',
      name: 'Normal Wins',
      url: '/lol-boost/normal-wins',
      icon: 'https://cdn.ggboost.com/images/services/lol/normalgames.webp',
      soloCurrentMin: null,
      soloCurrentMax: null,
      soloDesiredMin: 1,
      soloDesiredMax: 10,
      duoCurrentMin: null,
      duoCurrentMax: null,
      duoDesiredMin: 1,
      duoDesiredMax: 10,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'leveling',
      name: 'Leveling',
      url: '/lol-boost/leveling',
      icon: 'https://cdn.ggboost.com/images/services/lol/leveling.webp',
      soloCurrentMin: 1,
      soloCurrentMax: 500,
      soloDesiredMin: 2,
      soloDesiredMax: 500,
      duoCurrentMin: 1,
      duoCurrentMax: 500,
      duoDesiredMin: 2,
      duoDesiredMax: 500,
      isDuoAvailable: true,
      isSoloAvailable: true
    }
  ],

  /*---------------------------------------------------------------
  ---------------------- TEAMFIGHT TACTICS ------------------------
  ---------------------------------------------------------------*/
  'tft': [
    {
      service: 'divisions',
      name: 'Divisions',
      url: '/tft-boost',
      icon: 'https://cdn.ggboost.com/images/services/lol/divisions.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Iron IV', 'tft'),
      soloCurrentMax: DivisionsService.getValueByRank('Master', 'tft'),
      soloDesiredMin: DivisionsService.getValueByRank('Iron III', 'tft'),
      soloDesiredMax: DivisionsService.getValueByRank('Grandmaster', 'tft'),
      duoCurrentMin: null,
      duoCurrentMax: null,
      duoDesiredMin: null,
      duoDesiredMax: null,
      isDuoAvailable: false,
      isSoloAvailable: true
    },
    {
      service: 'doubleup',
      name: 'Double Up',
      url: '/tft-boost/double-up',
      icon: 'https://cdn.ggboost.com/images/tft/services/doubleup.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Iron IV', 'tft'),
      soloCurrentMax: DivisionsService.getValueByRank('Diamond I', 'tft'),
      soloDesiredMin: DivisionsService.getValueByRank('Iron III', 'tft'),
      soloDesiredMax: DivisionsService.getValueByRank('Master', 'tft'),
      duoCurrentMin: DivisionsService.getValueByRank('Iron IV', 'tft'),
      duoCurrentMax: DivisionsService.getValueByRank('Diamond I', 'tft'),
      duoDesiredMin: DivisionsService.getValueByRank('Iron III', 'tft'),
      duoDesiredMax: DivisionsService.getValueByRank('Master', 'tft'),
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'placements',
      name: 'Placements',
      url: '/tft-boost/placements',
      icon: 'https://cdn.ggboost.com/images/services/lol/placements.webp',
      soloCurrentMin: 0,
      soloCurrentMax: DivisionsService.getValueByRank('Grandmaster', 'tft'),
      soloDesiredMin: 1,
      soloDesiredMax: 5,
      duoCurrentMin: 0,
      duoCurrentMax: DivisionsService.getValueByRank('Grandmaster', 'tft'),
      duoDesiredMin: 1,
      duoDesiredMax: 5,
      isDuoAvailable: false,
      isSoloAvailable: true
    },
    {
      service: 'netwins',
      name: 'Net Wins',
      url: '/tft-boost/net-wins',
      icon: 'https://cdn.ggboost.com/images/services/lol/netwins.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Iron IV', 'tft'),
      soloCurrentMax: DivisionsService.getValueByRank('Grandmaster', 'tft'),
      soloDesiredMin: 1,
      soloDesiredMax: 3,
      duoCurrentMin: DivisionsService.getValueByRank('Iron IV', 'tft'),
      duoCurrentMax: DivisionsService.getValueByRank('Grandmaster', 'tft'),
      duoDesiredMin: 1,
      duoDesiredMax: 3,
      isDuoAvailable: false,
      isSoloAvailable: true
    },
    {
      service: 'normalgames',
      name: 'Normal Wins',
      url: '/tft-boost/normal-wins',
      icon: 'https://cdn.ggboost.com/images/services/lol/normalgames.webp',
      soloCurrentMin: null,
      soloCurrentMax: null,
      soloDesiredMin: 1,
      soloDesiredMax: 10,
      duoCurrentMin: null,
      duoCurrentMax: null,
      duoDesiredMin: 1,
      duoDesiredMax: 10,
      isDuoAvailable: true,
      isSoloAvailable: true
    }
  ],

  /*---------------------------------------------------------------
  -------------------------- WILD RIFT ----------------------------
  ---------------------------------------------------------------*/
  'wild-rift': [
    {
      service: 'divisions',
      name: 'Divisions',
      url: '/wild-rift-boost',
      icon: 'https://cdn.ggboost.com/images/services/lol/divisions.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Iron IV', 'wild-rift'),
      soloCurrentMax: DivisionsService.getValueByRank('Grandmaster', 'wild-rift'),
      soloDesiredMin: DivisionsService.getValueByRank('Iron III', 'wild-rift'),
      soloDesiredMax: DivisionsService.getValueByRank('Challenger', 'wild-rift'),
      duoCurrentMin: DivisionsService.getValueByRank('Iron IV', 'wild-rift'),
      duoCurrentMax: DivisionsService.getValueByRank('Diamond I', 'wild-rift'),
      duoDesiredMin: DivisionsService.getValueByRank('Iron III', 'wild-rift'),
      duoDesiredMax: DivisionsService.getValueByRank('Master', 'wild-rift'),
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'placements',
      name: 'Placements',
      url: '/wild-rift-boost/placements',
      icon: 'https://cdn.ggboost.com/images/services/lol/placements.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Iron IV', 'wild-rift'),
      soloCurrentMax: DivisionsService.getValueByRank('Master', 'wild-rift'),
      soloDesiredMin: 1,
      soloDesiredMax: 10,
      duoCurrentMin: DivisionsService.getValueByRank('Iron IV', 'wild-rift'),
      duoCurrentMax: DivisionsService.getValueByRank('Master', 'wild-rift'),
      duoDesiredMin: 1,
      duoDesiredMax: 10,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'normalgames',
      name: 'Normal Wins',
      url: '/wild-rift-boost/normal-wins',
      icon: 'https://cdn.ggboost.com/images/services/lol/normalgames.webp',
      soloCurrentMin: null,
      soloCurrentMax: null,
      soloDesiredMin: 1,
      soloDesiredMax: 10,
      duoCurrentMin: null,
      duoCurrentMax: null,
      duoDesiredMin: 1,
      duoDesiredMax: 10,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
  ],

  /*---------------------------------------------------------------
  -------------------------- VALORANT -----------------------------
  ---------------------------------------------------------------*/
  'valorant': [
    {
      service: 'divisions',
      name: 'Rank Boost',
      url: '/valorant-boost',
      icon: 'https://cdn.ggboost.com/images/valorant/icons/divisions.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Iron I', 'valorant'),
      soloCurrentMax: DivisionsService.getValueByRank('Immortal III', 'valorant'),
      soloDesiredMin: DivisionsService.getValueByRank('Iron II', 'valorant'),
      soloDesiredMax: DivisionsService.getValueByRank('Radiant', 'valorant'),
      duoCurrentMin: DivisionsService.getValueByRank('Iron I', 'valorant'),
      duoCurrentMax: DivisionsService.getValueByRank('Immortal III', 'valorant'),
      duoDesiredMin: DivisionsService.getValueByRank('Iron II', 'valorant'),
      duoDesiredMax: DivisionsService.getValueByRank('Radiant', 'valorant'),
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'placements',
      name: 'Placements',
      url: '/valorant-boost/placements',
      icon: 'https://cdn.ggboost.com/images/valorant/icons/placements.webp',
      soloCurrentMin: 0,
      soloCurrentMax: DivisionsService.getValueByRank('Immortal III', 'valorant'),
      soloDesiredMin: 1,
      soloDesiredMax: 5,
      duoCurrentMin: 0,
      duoCurrentMax: DivisionsService.getValueByRank('Immortal III', 'valorant'),
      duoDesiredMin: 1,
      duoDesiredMax: 5,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'netwins',
      name: 'Net Wins',
      url: '/valorant-boost/net-wins',
      icon: 'https://cdn.ggboost.com/images/valorant/icons/netwins.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Iron I', 'valorant'),
      soloCurrentMax: DivisionsService.getValueByRank('Radiant', 'valorant'),
      soloDesiredMin: 1,
      soloDesiredMax: 5,
      duoCurrentMin: DivisionsService.getValueByRank('Iron I', 'valorant'),
      duoCurrentMax: DivisionsService.getValueByRank('Immortal III', 'valorant'),
      duoDesiredMin: 1,
      duoDesiredMax: 5,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'games',
      name: 'Duo Games',
      url: '/valorant-boost/duo-games',
      icon: 'https://cdn.ggboost.com/images/valorant/icons/games.webp',
      soloCurrentMin: null,
      soloCurrentMax: null,
      soloDesiredMin: null,
      soloDesiredMax: null,
      duoCurrentMin: DivisionsService.getValueByRank('Iron I', 'valorant'),
      duoCurrentMax: DivisionsService.getValueByRank('Radiant', 'valorant'),
      duoDesiredMin: 1,
      duoDesiredMax: 5,
      isDuoAvailable: true,
      isSoloAvailable: false
    },
    {
      service: 'normalgames',
      name: 'Unrated Wins',
      url: '/valorant-boost/unrated-wins',
      icon: 'https://cdn.ggboost.com/images/valorant/icons/normalgames.webp',
      soloCurrentMin: null,
      soloCurrentMax: null,
      soloDesiredMin: 1,
      soloDesiredMax: 10,
      duoCurrentMin: null,
      duoCurrentMax: null,
      duoDesiredMin: 1,
      duoDesiredMax: 10,
      isDuoAvailable: true,
      isSoloAvailable: true
    }
  ],

  /*---------------------------------------------------------------
  ------------------------ APEX LEGENDS ---------------------------
  ---------------------------------------------------------------*/
  'apex': [
    {
      service: 'divisions',
      name: 'Rank Boost',
      url: '/apex-legends/rank-boosting',
      icon: 'https://cdn.ggboost.com/images/apex/services/rank-boosting.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Rookie IV', 'apex'),
      soloCurrentMax: DivisionsService.getValueByRank('Diamond I', 'apex'),
      soloDesiredMin: DivisionsService.getValueByRank('Rookie III', 'apex'),
      soloDesiredMax: DivisionsService.getValueByRank('Master', 'apex'),
      duoCurrentMin: DivisionsService.getValueByRank('Rookie IV', 'apex'),
      duoCurrentMax: DivisionsService.getValueByRank('Diamond I', 'apex'),
      duoDesiredMin: DivisionsService.getValueByRank('Rookie III', 'apex'),
      duoDesiredMax: DivisionsService.getValueByRank('Master', 'apex'),
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    // {
    //   service: 'placements',
    //   name: 'Provisionals',
    //   url: '/apex-legends/provisional-boosting',
    //   icon: 'https://cdn.ggboost.com/images/apex/services/provisionals.webp',
    //   soloCurrentMin: 0,
    //   soloCurrentMax: DivisionsService.getValueByRank('Predator', 'apex'),
    //   soloDesiredMin: 1,
    //   soloDesiredMax: 10,
    //   duoCurrentMin: 0,
    //   duoCurrentMax: DivisionsService.getValueByRank('Predator', 'apex'),
    //   duoDesiredMin: 1,
    //   duoDesiredMax: 10,
    //   isDuoAvailable: true,
    //   isSoloAvailable: true
    // },
    {
      service: 'badges',
      name: 'Badges',
      url: '/apex-legends/badge-boosting',
      icon: 'https://cdn.ggboost.com/images/apex/services/badges.webp',
      soloCurrentMin: 0,
      soloCurrentMax: 0,
      soloDesiredMin: 0,
      soloDesiredMax: 100,
      duoCurrentMin: null,
      duoCurrentMax: null,
      duoDesiredMin: null,
      duoDesiredMax: null,
      isDuoAvailable: false,
      isSoloAvailable: true
    },
    {
      service: 'normalgames',
      name: 'Unranked Wins',
      url: '/apex-legends/unranked-wins',
      icon: 'https://cdn.ggboost.com/images/apex/services/normalgames.webp',
      soloCurrentMin: null,
      soloCurrentMax: null,
      soloDesiredMin: 1,
      soloDesiredMax: 10,
      duoCurrentMin: null,
      duoCurrentMax: null,
      duoDesiredMin: 1,
      duoDesiredMax: 10,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
  ],

  /*---------------------------------------------------------------
  ---------------------- Counter Strike 2 -------------------------
  ---------------------------------------------------------------*/
  'cs2': [
    {
      service: 'divisions',
      name: 'Premier',
      url: '/cs2/premier-boosting',
      icon: 'https://cdn.ggboost.com/images/cs2/icons/premier.webp',
      soloCurrentMin: DivisionsService.getValueByRank('0', 'cs2'),
      soloCurrentMax: DivisionsService.getValueByRank('34000', 'cs2'),
      soloDesiredMin: DivisionsService.getValueByRank('1000', 'cs2'),
      soloDesiredMax: DivisionsService.getValueByRank('35000', 'cs2'),
      duoCurrentMin: DivisionsService.getValueByRank('0', 'cs2'),
      duoCurrentMax: DivisionsService.getValueByRank('34000', 'cs2'),
      duoDesiredMin: DivisionsService.getValueByRank('1000', 'cs2'),
      duoDesiredMax: DivisionsService.getValueByRank('35000', 'cs2'),
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'placements',
      name: 'Placements',
      url: '/cs2/placements-boosting',
      icon: 'https://cdn.ggboost.com/images/cs2/icons/placements.webp',
      soloCurrentMin: 0,
      soloCurrentMax: 0,
      soloDesiredMin: 1,
      soloDesiredMax: 10,
      duoCurrentMin: 0,
      duoCurrentMax: 0,
      duoDesiredMin: 1,
      duoDesiredMax: 10,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'masteries',
      name: 'Competitive',
      url: '/cs2/competitive-boosting',
      icon: 'https://cdn.ggboost.com/images/cs2/icons/competitive.webp',
      soloCurrentMin: 1,
      soloCurrentMax: 17,
      soloDesiredMin: 1,
      soloDesiredMax: 18,
      duoCurrentMin: 1,
      duoCurrentMax: 17,
      duoDesiredMin: 1,
      duoDesiredMax: 18,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'netwins',
      name: 'Net Wins',
      url: '/cs2/premier-wins-boosting',
      icon: 'https://cdn.ggboost.com/images/cs2/icons/wins.webp',
      soloCurrentMin: 0,
      soloCurrentMax: 34,
      soloDesiredMin: 1,
      soloDesiredMax: 5,
      duoCurrentMin: 0,
      duoCurrentMax: 34,
      duoDesiredMin: 1,
      duoDesiredMax: 5,
      isDuoAvailable: true,
      isSoloAvailable: true
    }
  ],

  /*---------------------------------------------------------------
  ------------------------ MARVEL RIVALS --------------------------
  ---------------------------------------------------------------*/
  'marvel': [
    {
      service: 'divisions',
      name: 'Competitive',
      url: '/marvel-rivals-boost',
      icon: 'https://cdn.ggboost.com/images/marvel/services/competitive.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Bronze III', 'marvel'),
      soloCurrentMax: DivisionsService.getValueByRank('Celestial I', 'marvel'),
      soloDesiredMin: DivisionsService.getValueByRank('Bronze II', 'marvel'),
      soloDesiredMax: DivisionsService.getValueByRank('Eternity', 'marvel'),
      duoCurrentMin: DivisionsService.getValueByRank('Bronze III', 'marvel'),
      duoCurrentMax: DivisionsService.getValueByRank('Diamond I', 'marvel'),
      duoDesiredMin: DivisionsService.getValueByRank('Bronze II', 'marvel'),
      duoDesiredMax: DivisionsService.getValueByRank('Celestial III', 'marvel'),
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'netwins',
      name: 'Net Wins',
      url: '/marvel-rivals-boost/net-wins',
      icon: 'https://cdn.ggboost.com/images/marvel/services/netwins.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Bronze III', 'marvel'),
      soloCurrentMax: DivisionsService.getValueByRank('Eternity', 'marvel'),
      soloDesiredMin: 1,
      soloDesiredMax: 5,
      duoCurrentMin: DivisionsService.getValueByRank('Bronze III', 'marvel'),
      duoCurrentMax: DivisionsService.getValueByRank('Eternity', 'marvel'),
      duoDesiredMin: 1,
      duoDesiredMax: 5,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'normalgames',
      name: 'Quick Wins',
      url: '/marvel-rivals-boost/quick-wins',
      icon: 'https://cdn.ggboost.com/images/marvel/services/quickwins.webp',
      soloCurrentMin: null,
      soloCurrentMax: null,
      soloDesiredMin: 1,
      soloDesiredMax: 10,
      duoCurrentMin: null,
      duoCurrentMax: null,
      duoDesiredMin: 1,
      duoDesiredMax: 10,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'leveling',
      name: 'Leveling',
      url: '/marvel-rivals-boost/leveling',
      icon: 'https://cdn.ggboost.com/images/marvel/services/leveling.webp',
      soloCurrentMin: 1,
      soloCurrentMax: 14,
      soloDesiredMin: 15,
      soloDesiredMax: 15,
      duoCurrentMin: 1,
      duoCurrentMax: 14,
      duoDesiredMin: 15,
      duoDesiredMax: 15,
      isDuoAvailable: true,
      isSoloAvailable: true
    }
  ],

  /*---------------------------------------------------------------
  -------------------------- OVERWATCH ----------------------------
  ---------------------------------------------------------------*/
  'overwatch': [
    {
      service: 'divisions',
      name: 'Rank Boost',
      url: '/overwatch-boost',
      icon: 'https://cdn.ggboost.com/images/services/apex/divisions.webp',
      soloCurrentMin: DivisionsService.getValueByRank('Bronze 5', 'overwatch'),
      soloCurrentMax: DivisionsService.getValueByRank('Grandmaster 1', 'overwatch'),
      soloDesiredMin: DivisionsService.getValueByRank('Bronze 4', 'overwatch'),
      soloDesiredMax: DivisionsService.getValueByRank('Top 500', 'overwatch'),
      duoCurrentMin: DivisionsService.getValueByRank('Bronze 5', 'overwatch'),
      duoCurrentMax: DivisionsService.getValueByRank('Grandmaster 1', 'overwatch'),
      duoDesiredMin: DivisionsService.getValueByRank('Bronze 4', 'overwatch'),
      duoDesiredMax: DivisionsService.getValueByRank('Top 500', 'overwatch'),
      isDuoAvailable: true,
      isSoloAvailable: true
    },
    {
      service: 'placements',
      name: 'Provisionals',
      url: '/overwatch/provisional-boosting',
      icon: 'https://cdn.ggboost.com/images/services/apex/placements.webp',
      soloCurrentMin: 0,
      soloCurrentMax: DivisionsService.getValueByRank('Top 500', 'overwatch'),
      soloDesiredMin: 1,
      soloDesiredMax: 5,
      duoCurrentMin: 0,
      duoCurrentMax: DivisionsService.getValueByRank('Top 500', 'overwatch'),
      duoDesiredMin: 1,
      duoDesiredMax: 5,
      isDuoAvailable: true,
      isSoloAvailable: true
    },
  ],
}
